import { useCallback, useRef } from 'react'
import { useUpdateEffect } from 'react-use'

const SCROLL_LOCK_CLASSES = ['overflow-hidden']
const MOBILE_SAFARI_SCROLL_LOCK_CLASSES = ['fixed', 'left-0', 'right-0']

export function useScrollLock(options?: { isLocked: boolean; targetElement?: HTMLElement }) {
  const top = useRef<number | undefined>(undefined)

  const getTargetElement = useCallback(
    () => options?.targetElement || document.getElementsByTagName('body')[0],
    [options?.targetElement],
  )

  const lockScroll = useCallback(() => {
    top.current = document.documentElement.scrollTop

    const targetElement = getTargetElement()
    targetElement.classList.add(...(isMobileSafari() ? MOBILE_SAFARI_SCROLL_LOCK_CLASSES : SCROLL_LOCK_CLASSES))
  }, [getTargetElement])

  const unlockScroll = useCallback(() => {
    if (isMobileSafari()) scrollTo({ top: top.current })

    const targetElement = getTargetElement()
    targetElement.classList.remove(...(isMobileSafari() ? MOBILE_SAFARI_SCROLL_LOCK_CLASSES : SCROLL_LOCK_CLASSES))
  }, [getTargetElement])

  useUpdateEffect(() => {
    // * do not lock/unlock if no params provided (when accessing lockScroll and unlockScroll functions directly)
    if (typeof options?.isLocked === 'boolean') {
      if (options?.isLocked) lockScroll()
      else unlockScroll()
    }
  }, [options?.isLocked, lockScroll, unlockScroll])

  return { lockScroll, unlockScroll }
}

function isMobileSafari() {
  const ua = window.navigator.userAgent
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
  const webkit = !!ua.match(/WebKit/i)
  return iOS && webkit && !ua.match(/CriOS/i)
}
